var _rect, _g, _rect2, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFourthBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 232,
    viewBox: "0 0 1600 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4550_70830",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 86,
    width: 620,
    height: 134
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 86,
    width: 620,
    height: 134,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4550_70830)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4550_70830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22461 229.676H561.055V146.491C303.936 132.879 83.3685 196.276 5.22461 229.676Z",
    fill: "#B0DEF2"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4550_70830",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 980,
    y: 86,
    width: 620,
    height: 134
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 134,
    transform: "matrix(-1 0 0 1 1600 86)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4550_70830)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4550_70830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1594.78 229.676H1038.95V146.491C1296.06 132.879 1516.63 196.276 1594.78 229.676Z",
    fill: "#F5E2C8"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4550_70830)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4550_70830)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 40,
    width: 1144,
    height: 180,
    fill: "black",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 40,
    width: 1144,
    height: 180,
    fill: "url(#paint0_linear_4550_70830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 20H1348L1372 40H228L252 20Z",
    fill: "url(#paint1_linear_4550_70830)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4550_70830",
    x: -55.2754,
    y: 84.1045,
    width: 676.83,
    height: 206.071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.25,
    result: "effect1_foregroundBlur_4550_70830"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4550_70830",
    x: 978.445,
    y: 84.1045,
    width: 676.83,
    height: 206.071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.25,
    result: "effect1_foregroundBlur_4550_70830"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4550_70830",
    x: 212,
    y: 0,
    width: 1176,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4550_70830"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4550_70830",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4550_70830",
    x: 218.9,
    y: 30.9,
    width: 1162.2,
    height: 198.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.55,
    result: "effect1_foregroundBlur_4550_70830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4550_70830",
    x1: 228,
    y1: 130,
    x2: 1372,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDBD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4550_70830",
    x1: 228,
    y1: 30,
    x2: 1372,
    y2: 29.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5EDEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFourthBox);
export default __webpack_public_path__ + "static/media/ic-fourth-box.50a719105b90e69fb78cd1ba20a9b6ee.svg";
export { ForwardRef as ReactComponent };